<template>
  <v-card>
    <s-crud
      :config="config"
      title="Regularizaciones"
      :filter="filter"
      add
      addNoFunction
      @add="addWorker($event)"
      edit
      @edit="editWorker($event)"
      remove
      ref="ScrudMarking"
      @save="save($event)"
      @rowSelected="rowSelected($event)"
      searchInput
      filtersActive
      btnsearch
      colorToolbar="info"
      no-full
    >
      <template v-slot:options>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              v-on="on"
              small
              elevation="0"
              @click="openReport"
              :disabled="!item || Object.keys(item).length === 0"
            >
              <v-icon color="default" x-small> fas fa-eye </v-icon>
            </v-btn>
          </template>
          <span>Visualizar Reporte</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              v-on="on"
              small
              elevation="0"
              @click="changeStatus"
              :disabled="!item || Object.keys(item).length === 0"
            >
              <v-icon color="default" x-small> fas fa-calculator </v-icon>
            </v-btn>
          </template>
          <span>Calculo de Estado</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" small elevation="0" @click="duplicate">
              <v-icon color="default" x-small> fas fa-copy </v-icon>
            </v-btn>
          </template>
          <span>Duplicar</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              v-on="on"
              small
              elevation="0"
              @click="openScheduleDetail"
              :disabled="!item || Object.keys(item).length === 0"
            >
              <v-icon color="default" x-small> mdi-calendar-clock </v-icon>
            </v-btn>
          </template>
          <span>Horarios</span>
        </v-tooltip>
      </template>
      <template v-slot:filter>
        <v-container>
          <v-row>
            <v-col cols="12" md="3">
              <s-select-campaign-se label="Campaña" v-model="filter.CmpID" clearable />
              <s-select
                label="Cuadrilla"
                :items="quadrille"
                autocomplete
                item-text="GngName"
                item-value="GngID"
                v-model="filter.GngID"
                clearable
              ></s-select>
              <div class="d-flex align-center">
                <s-toolbar-person
                  class="flex-grow-1"
                  noCamera
                  label="Trabajador (DNI)"
                  noEdit
                  v-model="filter.PrsDocumentNumber"
                  @returnPerson="returnPerson($event)"
                />
                <v-btn icon x-small color="dark" @click="clearPerson()" class="ml-2 mt-3">
                  <v-icon>mdi-broom</v-icon>
                </v-btn>
              </div>
            </v-col>

            <v-col cols="12" md="3">
              <s-select-definition
                label="Tipo de Planilla"
                :def="1060"
                v-model="filter.TypePayroll"
                clearable
              ></s-select-definition>
              <s-switch
                label="Por Fecha"
                v-model="filter.SelectDate"
                :true-value="true"
                :false-value="false"
                class="mt-2"
              />
              <s-text disabled label="Nombre" v-model="NtpFullName"></s-text>
            </v-col>

            <v-col cols="12" md="3">
              <s-select-area
                label="Area"
                v-model="filter.AreID"
                clearable
              ></s-select-area>
              <s-date
                label="Fecha desde"
                :disabled="disabledDate"
                v-model="filter.MrkDateEntry"
                clearable
              ></s-date>
            </v-col>
            <v-col cols="12" md="3">
              <s-select-definition
                label="Turno"
                :def="1278"
                v-model="filter.TypeTurn"
                clearable
              ></s-select-definition>
              <s-date
                label="Fecha hasta"
                :disabled="disabledDate"
                v-model="filter.MrkDateExit"
                clearable
              ></s-date>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:TypeTurno="{ row }">
        <v-chip
          v-if="row.TypeTurno && row.TypeTurno > 0"
          :color="getShiftColor(row.TypeTurno)"
          small
          dark
          outlined
          label
          @click="toggleShift(row)"
          class="shift-chip-menu"
        >
          {{ getShiftText(row.TypeTurno) }}
          <v-icon x-small class="m-1">mdi mdi-arrow-right-bold</v-icon>
          {{ getShiftText(row.TypeTurno == 1 ? 2 : 1) }}
        </v-chip>
        <v-chip v-else small outlined label class="shift-chip-menu">
          Sin Horario
        </v-chip>
      </template>
    </s-crud>
    <v-dialog v-model="dialogAdd" max-width="1100px" persistent>
      <v-card class="elevation-8" style="border-radius: 12px; overflow: hidden">
        <!-- Header minimalista con gradiente sutil -->
        <div
          style="
            background: linear-gradient(135deg, #6e6f71 0%, #8e8f91 100%);
            padding: 24px 32px;
          "
        >
          <div style="display: flex; justify-content: space-between; align-items: center">
            <div>
              <h2
                style="
                  color: white;
                  font-weight: 300;
                  font-size: 24px;
                  margin: 0;
                  letter-spacing: 0.5px;
                "
              >
                Marcaciones de Trabajador
              </h2>
              <p
                style="
                  color: rgba(255, 255, 255, 0.8);
                  font-size: 13px;
                  margin: 4px 0 0 0;
                  font-weight: 300;
                "
              >
                {{ itemAdd.Edit ? "Editar registro" : "Registrar múltiples marcaciones" }}
              </p>
            </div>
            <div style="display: flex; gap: 12px">
              <v-btn @click="dialogAdd = false" icon color="white">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </div>

        <!-- Contenido con padding espacioso -->
        <v-container style="padding: 32px 36px; background: #fafafa">
          <!-- Sección de Trabajador -->
          <div
            style="
              background: white;
              border-radius: 8px;
              padding: 24px;
              margin-bottom: 24px;
              box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
            "
          >
            <p
              style="
                font-size: 11px;
                font-weight: 600;
                text-transform: uppercase;
                letter-spacing: 1px;
                color: #666;
                margin: 0 0 16px 0;
              "
            >
              Información del Trabajador
            </p>
            <v-row>
              <v-col cols="12" sm="4" md="3">
                <s-toolbar-person
                  noCamera
                  label="DNI / Doc."
                  noEdit
                  v-model="itemAdd.PrsDocumentNumber"
                  @returnPerson="returnPersona($event, item)"
                />
              </v-col>
              <v-col cols="12" sm="8" md="9">
                <s-text
                  readonly
                  label="Nombre Completo"
                  v-model="itemAdd.NtpFullName"
                  style="font-weight: 500"
                ></s-text>
              </v-col>
            </v-row>
          </div>

          <!-- Sección de Marcaciones -->
          <div
            style="
              background: white;
              border-radius: 8px;
              padding: 24px;
              box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
            "
          >
            <p
              style="
                font-size: 11px;
                font-weight: 600;
                text-transform: uppercase;
                letter-spacing: 1px;
                color: #666;
                margin: 0 0 20px 0;
              "
            >
              Registro de Marcaciones
            </p>

            <!-- Modo Edición Individual -->
            <template v-if="itemAdd.Edit">
              <v-row>
                <v-col cols="12" sm="6" md="3">
                  <s-date
                    label="Fecha"
                    v-model="itemAdd.MrkDate"
                    :key="`date-${keyReset}`"
                  ></s-date>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <s-text type="time" label="Hora" v-model="itemAdd.MrkTime"></s-text>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <s-select-definition
                    label="Tipo Marcación"
                    :def="1400"
                    v-model="itemAdd.MrkType"
                    :dgr="95"
                  ></s-select-definition>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <s-select-definition
                    label="Rango"
                    :def="1524"
                    v-model="itemAdd.MrkRange"
                  ></s-select-definition>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <s-select-definition
                    label="Incidencia de Marcado"
                    :def="1527"
                    :dgr="90"
                    v-model="itemAdd.MrkTypeStatusMarking"
                  ></s-select-definition>
                </v-col>
              </v-row>
            </template>

            <!-- Modo Alta Múltiple -->
            <template v-else>
              <div
                v-for="(row, idx) in itemAdd.rows"
                :key="`row-${idx}`"
                style="
                  background: #f8f9fa;
                  border-radius: 6px;
                  padding: 20px;
                  margin-bottom: 16px;
                  border-left: 3px solid #8e8f91;
                "
              >
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 12px;
                  "
                >
                  <span
                    style="
                      font-size: 12px;
                      font-weight: 600;
                      color: #666;
                      letter-spacing: 0.5px;
                    "
                  >
                    MARCACIÓN {{ idx + 1 }}
                  </span>
                  <v-btn
                    icon
                    x-small
                    color="error"
                    @click="removeRow(idx)"
                    :disabled="itemAdd.rows.length === 1"
                    style="opacity: 0.7"
                  >
                    <v-icon size="18">mdi-delete</v-icon>
                  </v-btn>
                </div>
                <v-row>
                  <v-col cols="12" sm="6" md="3">
                    <s-date label="Fecha" v-model="row.date" clearable></s-date>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <s-text type="time" label="Hora" v-model="row.time"></s-text>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <s-select-definition
                      label="Tipo Marcación"
                      :def="1400"
                      v-model="row.type"
                      :dgr="95"
                      clearable
                    ></s-select-definition>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <s-select-definition
                      label="Incidencia"
                      :def="1527"
                      :dgr="90"
                      v-model="row.MrkTypeStatusMarking"
                      clearable
                    ></s-select-definition>
                  </v-col>
                </v-row>
              </div>

              <v-btn
                text
                color="#8e8f91"
                @click="addRow"
                style="margin-top: 8px; text-transform: none; font-weight: 500"
              >
                <v-icon left size="20">mdi-plus-circle-outline</v-icon>
                Agregar otra marcación
              </v-btn>
            </template>

            <!-- Observaciones -->
            <v-row style="margin-top: 24px">
              <v-col cols="12">
                <v-divider style="margin-bottom: 20px"></v-divider>
                <s-textarea
                  label="Observaciones"
                  v-model="itemAdd.MrkObservation"
                  :rows="3"
                  outlined
                ></s-textarea>
              </v-col>
            </v-row>
          </div>
          <!-- Footer con botones -->
          <v-card-actions
            style="
              background: white;
              padding: 20px 32px;
              border-top: 1px solid #e0e0e0;
              display: flex;
              justify-content: flex-end;
              gap: 12px;
            "
          >
            <v-btn
              @click="dialogAdd = false"
              text
              style="font-weight: 500; text-transform: none; letter-spacing: 0.3px"
            >
              Cancelar
            </v-btn>
            <v-btn
              @click="save()"
              color="primary"
              style="font-weight: 500; text-transform: none; letter-spacing: 0.3px"
            >
              <v-icon left size="20">mdi-content-save</v-icon>
              Guardar
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
    <schedule-detail-modal
      v-model="dialogScheduleDetail"
      :schedule-data="filterScheduleDetail"
      :dialog-name="dialogName"
      @saved="$refs.ScrudMarking.refresh()"
      @close="dialogScheduleDetail = false"
    />

    <report-modal
      v-if="item"
      v-model="dialogReport"
      :wkr-id="item.WkrID || 0"
      :initDate="item.MrkDateEntry || ''"
      :endDate="item.MrkDateEntry || ''"
      :worker-name="item.NtpFullName || ''"
      @close="dialogReport = false"
    />

    <Loader v-if="isLoading" />
  </v-card>
</template>

<script>
import _sMarking from "../../services/HumanResource/HmnMarkingService";
import _sBiometricEquipmentService from "@/services/HumanResource/BiometricEquipmentService";
import SText from "../../components/Utils/SText.vue";
import sToolbarPerson from "@/components/Utils/Person/sToolbarPerson";
import _sQuadriService from "@/services/HumanResource/hmnGang.js";
import _WorkService from "@/services/HumanResource/WorkerService";
import ScheduleDetailModal from "@/components/HumanResource/ScheduleDetailModal.vue";
import _sChangeShiftMassService from "@/services/HumanResource/ChangeShiftMass";
import Loader from "@/components/Layout/Loader.vue";
import ReportModal from "@/components/HumanResource/ReportModal.vue";

export default {
  components: {
    SText,
    sToolbarPerson,
    ScheduleDetailModal,
    Loader,
    ReportModal,
  },
  data() {
    return {
      itemAdd: {
        rows: [{ date: this.$fun.getDate(), time: "", type: 1 }],
      },
      dialogAdd: false,
      disabledDate: false,
      quadrille: [],
      keyReset: 0,
      filter: {
        CmpID: null,
        TypePayroll: null,
        AreID: null,
        GngID: null,
        TypeTurn: null,
        SelectDate: true,
        MrkDateEntry: this.$fun.getDate(),
        MrkDateExit: this.$fun.getDate(),
        PrsDocumentNumber: "",
      },
      NtpFullName: null,
      MrkOfficialRefreshment: 60,
      item: {},
      WkrID: 0,
      config: {
        service: _sMarking,
        model: {
          MrkID: "ID",
          NtpID: "int",
          NtpFullName: "string",
          PrsDocumentNumber: "string",
          MrkDateEntry: "date",
          MrkDateExit: "date",
          MrkRegistrationDate: "datetime",
          MrkOfficialEntry: "datetime",
          MrkOfficialExit: "datetime",
          MrkDateMarking: "date",
          MrkMarking: "time2",
        },
        filters: [
          // { text: "ID", value: "MrkID" },
          { text: "Documento", value: "PrsDocumentNumber" },
          { text: "Trabajador", value: "NtpFullName" },
          { text: "Area", value: "AreName" },
          { text: "Dia", value: "MrkRangeName" },
          { text: "F. Marcacion", value: "MrkDateMarking" },
          { text: "Rango", value: "MrkRange" },
          { text: "Hora Marcacion", value: "MrkMarking" },
          { text: "Estado Marcacion", value: "StatusMarkingName" },
          { text: "Estado", value: "MrkStatusMarking" },
          { text: "Refrigerio (mm)", value: "MrkOfficialRefreshment" },
          { text: "Temprano", value: "MrkEarly" },
          { text: "Tardanza", value: "MrkTardiness" },
          { text: "Tipo", value: "MrkType" },
          { text: "Equipo", value: "BieEquipmentName" },
          { text: "Observacion", value: "MrkObservation" },
        ],
        headers: [
          { text: "ID", value: "MrkID" },
          { text: "Turno", value: "TypeTurno", width: 100 },
          { text: "Documento", value: "PrsDocumentNumber" },
          { text: "Trabajador", value: "NtpFullName" },
          { text: "Area", value: "AreName" },
          { text: "Dia", value: "MrkRangeName" },
          { text: "F. Marcacion", value: "MrkDateMarking" },
          { text: "Rango", value: "MrkRange" },
          { text: "Hora Marcacion", value: "MrkMarking" },
          { text: "Estado Marcacion", value: "StatusMarkingName" },
          { text: "Estado", value: "MrkStatusMarking" },
          // { text: "Fecha Registro", value: "MrkRegistrationDate" },
          // { text: "Entrada Oficial", value: "MrkOfficialEntry" },
          // { text: "Salida Oficial", value: "MrkOfficialExit" },
          { text: "Refrigerio (mm)", value: "MrkOfficialRefreshment" },
          { text: "Temprano", value: "MrkEarly" },
          { text: "Tardanza", value: "MrkTardiness" },
          { text: "Tipo", value: "MrkTypeName" },
          { text: "Equipo", value: "BieEquipmentName" },
          // { text: "Fecha Marcacion", value: "MrkDateMarking" },
          // { text: "Fecha Entrada", value: "MrkDateEntry" },
          // { text: "Fecha Salida", value: "MrkDateExit" },
          { text: "Observacion", value: "MrkObservation" },
        ],
      },
      configSelectBiometric: {
        url: _sBiometricEquipmentService.list(),
        params: {},
        title: "Biométrico",
      },
      dialogScheduleDetail: false,
      dialogName: "",
      filterScheduleDetail: {
        SdwID: 0,
        WkrID: 0,
      },
      isLoading: false,
      dialogReport: false,
    };
  },
  methods: {
    returnPersona(value, item) {
      if (value) {
        const existingRows = Array.isArray(this.itemAdd.rows)
          ? this.itemAdd.rows
          : [
              {
                date: this.$fun.getDate(),
                time: "",
                type: 1,
                MrkTypeStatusMarking: this.itemAdd.MrkTypeStatusMarking || null,
              },
            ];
        this.itemAdd = {
          ...this.itemAdd,
          rows: existingRows,
          NtpFullName: value.NtpFullName,
          PrsDocumentNumber: value.PrsDocumentNumber,
          NtpID: value.NtpID,
          PrsID: value.PrsID,
          WkrID: value.WkrID,
        };

        try {
          _WorkService
            .DetailByNtpID(value.NtpID, this.$fun.getUserID())
            .then((response) => {
              this.itemAdd.WkrID = response.data.WkrID;
            });
        } catch (error) {
          console.error("Error cargando datos del trabajador:", error);
        }
      }
    },
    addWorker() {
      this.dialogAdd = true;
      this.itemAdd = {
        MrkType: 1,
        rows: [{ date: this.$fun.getDate(), time: "", type: 1 }],
      };
      this.keyReset++;
    },
    editWorker(item) {
      this.dialogAdd = true;
      this.itemAdd = { ...item };
      this.itemAdd.Edit = true;
    },
    async returnPerson(event) {
      if (event) {
        this.NtpFullName = event.NtpFullName;
        this.filter.PrsDocumentNumber = event.PrsDocumentNumber;
        this.NtpID = event.NtpID;
        this.PrsID = event.PrsID;
        this.WkrID = event.WkrID;

        try {
          const detailResponse = await _WorkService.DetailByNtpID(
            event.NtpID,
            this.$fun.getUserID()
          );
          this.WkrID = detailResponse.data.WkrID;
        } catch (error) {
          console.error("Error cargando datos del trabajador:", error);
        }
      }
    },
    clearPerson() {
      this.NtpFullName = "";
      this.filter.PrsDocumentNumber = "";
      this.NtpID = null;
      this.PrsID = null;
      this.WkrID = 0;
    },
    save() {
      if (!this.itemAdd.PrsDocumentNumber) {
        this.$fun.alert("El campo Documento es Obligatorio", "warning");
        return;
      }
      // En alta múltiple cada fila tiene su propia fecha; en edición se valida la fecha individual
      if (this.itemAdd.Edit && !this.itemAdd.MrkDate) {
        this.$fun.alert("El campo Fecha es Obligatorio", "warning");
        return;
      }
      if (this.itemAdd.Edit && !this.itemAdd.MrkTypeStatusMarking) {
        this.$fun.alert("El campo Estado es Obligatorio", "warning");
        return;
      }
      if ([1, 2].includes(this.itemAdd.MrkTypeStatusMarking)) {
        this.itemAdd.MrkIncidence = this.itemAdd.MrkTypeStatusMarking === 1 ? 0 : 1;
      }

      const base = {
        NtpFullName: this.itemAdd.NtpFullName,
        PrsDocumentNumber: this.itemAdd.PrsDocumentNumber,
        NtpID: this.itemAdd.NtpID,
        PrsID: this.itemAdd.PrsID,
        MrkID: this.itemAdd.MrkID,
        WkrID: this.itemAdd.WkrID,
        MrkDate: this.itemAdd.MrkDate,
        MrkTypeStatusMarking: this.itemAdd.MrkTypeStatusMarking,
        MrkIncidence: this.itemAdd.MrkIncidence,
        MrkObservation: this.itemAdd.MrkObservation || "marcación-manual",
        UsrID: this.$fun.getUserID(),
        SecStatus: 1,
        MrkStatus: 1,
        UsrCreateID: this.$fun.getUserID(),
        UsrUpdateID: this.$fun.getUserID(),
      };
      // console.log("base de datos", base);
      
      // Edición individual: una sola marcación con MrkType y hora
      if (this.itemAdd.Edit) {
        if (!this.itemAdd.MrkTime) {
          this.$fun.alert("Debe ingresar la hora", "warning");
          return;
        }
        if (!this.itemAdd.MrkType) {
          this.$fun.alert("Debe seleccionar el Tipo de Marcación", "warning");
          return;
        }
        const payload = {
          ...base,
          MrkMarking: this.$fun.combineDateTime(
            this.itemAdd.MrkDate,
            this.itemAdd.MrkTime
          ),
          MrkType: this.itemAdd.MrkType,
          MrkRange: this.itemAdd.MrkRange,
        };
        // console.log("retornando", payload);
        
        this.confirmAndSave([payload]);
        return;
      }

      // Alta múltiple: recorrer filas
      const items = [];
      if (!Array.isArray(this.itemAdd.rows) || this.itemAdd.rows.length === 0) {
        this.$fun.alert("Agregue al menos una marcación", "warning");
        return;
      }
      for (const r of this.itemAdd.rows) {
        if (!r.date) {
          this.$fun.alert("Todas las filas deben tener fecha", "warning");
          return;
        }
        if (!r.time) {
          this.$fun.alert("Todas las filas deben tener hora", "warning");
          return;
        }
        if (!r.type) {
          this.$fun.alert("Todas las filas deben tener Tipo de Marcación", "warning");
          return;
        }
        const status =
          r.MrkTypeStatusMarking != null
            ? r.MrkTypeStatusMarking
            : this.itemAdd.MrkTypeStatusMarking;
        const incidence = [1, 2].includes(status)
          ? status === 1
            ? 0
            : 1
          : this.itemAdd.MrkIncidence;
        items.push({
          ...base,
          MrkMarking: this.$fun.combineDateTime(r.date, r.time),
          MrkType: r.type,
          MrkTypeStatusMarking: status,
          MrkIncidence: incidence,
        });
      }
      this.confirmAndSave(items);
    },
    confirmAndSave(items) {
      this.$fun.alert("Seguro que desea Guardar", "question").then(async (r) => {
        if (!r.value) return;
        try {
          this.isLoading = true;
          for (const it of items) {
            /* eslint-disable no-await-in-loop */
            const resp = await _sMarking.save(it, this.$fun.getUserID());
            if (resp.status !== 200) throw new Error("error");
          }
          this.isLoading = false;
          this.$fun.alert("Registro(s) guardado(s) correctamente", "success");
          this.$refs.ScrudMarking.refresh();
          this.dialogAdd = false;
        } catch (e) {
          this.isLoading = false;
        }
      });
    },
    addRow() {
      if (!this.itemAdd.rows) this.itemAdd.rows = [];
      this.itemAdd.rows.push({
        date: this.$fun.getDate(),
        time: "",
        type: this.itemAdd.MrkType || 1,
        MrkTypeStatusMarking: this.itemAdd.MrkTypeStatusMarking || null,
      });
    },
    removeRow(idx) {
      if (!this.itemAdd.rows) return;
      this.itemAdd.rows.splice(idx, 1);
    },
    rowSelected(item) {
      if (item && item.length > 0) {
        this.item = item[0];
      } else {
        this.item = null;
      }
    },
    duplicate() {
      if (!this.item || Object.keys(this.item).length === 0) {
        this.$fun.alert("Debe seleccionar un registro para duplicar", "warning");
        return;
      }

      // Preparamos el objeto para duplicar sin perder la capacidad de alta múltiple
      this.itemAdd = {
        rows: [
          {
            date: this.$fun.getDate(),
            time: "",
            type: this.item && this.item.MrkType ? this.item.MrkType : 1,
            MrkTypeStatusMarking: null,
          },
        ],
      };
      // Solo los campos que necesitas
      const select = {
        NtpFullName: this.item.NtpFullName,
        PrsDocumentNumber: this.item.PrsDocumentNumber,
        NtpID: this.item.NtpID,
        PrsID: this.item.PrsID,
        WkrID: this.item.WkrID,
        MrkDate: this.item.MrkDate,
        MrkTime: this.item.MrkTime,
        MrkTypeStatusMarking: this.item.MrkTypeStatusMarking,
        MrkObservation: this.item.MrkObservation,
      };

      this.$fun
        .alert(`¿Está seguro de duplicar el registro seleccionado?`, "question")
        .then((val) => {
          if (val.value) {
            this.dialogAdd = true;
            this.itemAdd = { ...this.itemAdd, ...select };
            this.keyReset++;
          }
        });
    },
    getQuadrille() {
      let obj = {
        SecStatus: 1,
      };
      _sQuadriService.list(obj, this.$fun.getUserID()).then((resp) => {
        if (resp.status == 200) {
          this.quadrille = resp.data;
        }
      });
    },
    changeStatus() {
      this.$fun.alert("Está seguro de realizar el calculo?", "question").then((r) => {
        if (r.value) {
          this.calculateStatus();
        }
      });
    },
    calculateStatus() {
      this.filter.WkrID = this.WkrID;
      this.filter.UsrUpdateID = this.$fun.getUserID();
      this.isLoading = true;
      _sMarking.calculateStatus(this.filter, this.$fun.getUserID()).then((r) => {
        this.$fun.alert("Calculo realizado correctamente", "success");
        this.isLoading = false;
        this.$refs.ScrudMarking.refresh();
      });
    },
    async openScheduleDetail() {
      if (!this.item || Object.keys(this.item).length === 0) {
        this.$fun.alert("Debe seleccionar un registro", "warning");
        return;
      }

      if (!this.item.SdwID) {
        this.$fun.alert("El trabajador no tiene horario asignado", "warning");
        return;
      }

      this.dialogName = `Horarios: ${this.item.NtpFullName}`;
      this.filterScheduleDetail = {
        WkrID: this.item.WkrID,
        SdwID: this.item.SdwID,
      };

      this.dialogScheduleDetail = true;
    },
    getShiftText(ShiftValue) {
      const Shifts = {
        1: "Día",
        2: "Noche",
      };
      return Shifts[ShiftValue] || "Sin turno";
    },

    getShiftColor(ShiftValue) {
      const colors = {
        1: "blue",
        2: "purple",
      };
      return colors[ShiftValue] || "grey";
    },
    toggleShift(row) {
      const current = row.TypeTurno;
      const newShift = current === 1 ? 2 : 1;

      const shiftToAssign = current === null || current === 0 ? 1 : newShift;

      this.updateShift(row.SdwID, shiftToAssign);
    },
    updateShift(SdwID, newShift) {
      const updateData = {
        SdwID: SdwID,
        TypeTurnoEdit: newShift,
        UsrUpdateID: this.$fun.getUserID(),
      };

      _sChangeShiftMassService
        .save(updateData, this.$fun.getUserID())
        .then((response) => {
          if (response.status === 200) {
            this.$fun.alert("Turno actualizado correctamente", "success");
            this.$refs.ScrudMarking.refresh();
          }
        });
      // .catch((error) => {
      //   console.error("Error actualizando turno:", error);
      //   this.$fun.alert("Error al actualizar el turno", "error");
      // });
    },
    openReport() {
      if (!this.item || Object.keys(this.item).length === 0) {
        this.$fun.alert("Debe seleccionar un registro", "warning");
        return;
      }
      this.dialogReport = true;
    },
  },
  created() {
    this.getQuadrille();
  },
  watch: {
    "filter.SelectDate"(value) {
      if (!value) {
        this.filter.MrkDateEntry = null;
        this.filter.MrkDateExit = null;
        this.disabledDate = true;
      } else {
        this.disabledDate = false;
        this.filter.MrkDateEntry = this.$fun.getDate();
        this.filter.MrkDateExit = this.$fun.getDate();
      }
    },
  },
};
</script>

<style scoped>
.shift-chip-menu {
  cursor: pointer;
  transition: all 0.2s;
}

.shift-chip-menu:hover {
  transform: scale(1.02);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}
</style>
